import React, { Fragment, useEffect, useState } from "react";
import { motion } from "framer-motion";
import medeelel from "../../api/medee-medeelel";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import { Link } from "react-router-dom";
import Mcc from "../../components/mcc/Mcc";

const MedeelelPage = ({ isDark, onToggleDark }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(medeelel.length / itemsPerPage);

  // Scroll top when page changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handlePageClick = (pageNum) => {
    setCurrentPage(pageNum);
  };

  // Calculate current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = medeelel
    .slice(indexOfFirstItem, indexOfLastItem)
    .reverse();
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="main">
          <PageTitle
            pageTitle={"Мэдээ мэдээлэл"}
            pagesub={"мэдээлэл"}
            pageTop={"Our"}
            tolink={"#medeelel"}
          />
          <section className="blog pt-80 pb-30">
            <div className="container">
              <Mcc />
              <div id="medeelel" className="row">
                {currentItems.map((blog, index) => (
                  <div className={blog.col} key={index}>
                    <div className={`blogBlock ${blog.styleClass} mb-60`}>
                      <figure className="blogBlock__figure">
                        <Link
                          onClick={ClickHandler}
                          to={`/medee-medeelel/${blog.slug}`}
                          className="blogBlock__figure__link"
                        >
                          <img
                            src={blog.screens}
                            alt="Blog"
                            className="blogBlock__figure__image"
                          />
                        </Link>
                      </figure>
                      <div className="blogBlock__content">
                        <div className="blogBlock__header">
                          <span className="blogBlock__tag tag mb-20">
                            {blog.thumb}
                          </span>
                          <h2 className="blogBlock__heading heading text-uppercase mb-20">
                            <Link
                              to={`/medee-medeelel/${blog.slug}`}
                              className="blogBlock__heading__link"
                            >
                              {blog.title}
                            </Link>
                          </h2>
                        </div>
                        <div className="blogBlock__body mb-30">
                          <p className="blogBlock__text text">
                            {blog.description.slice(0, 60) + "....."}
                          </p>
                        </div>
                        <div className="blogBlock__meta">
                          <ul className="blogBlock__meta__list">
                            {/* <li>
                              <Link
                                to={`/blog-details/${blog.slug}`}
                                className="blogBlock__metaUser"
                              >
                                <img
                                  className="blogBlock__metaUser__thumb"
                                  src={blog.authorImg}
                                  alt="User"
                                />
                                <span className="blogBlock__metaUser__name">
                                  {blog.author}
                                </span>
                              </Link>
                            </li>
                            <li>
                              <button className="blogBlock__reactButton">
                                <span className="blogBlock__reactButton__count">
                                  {blog.comment}
                                </span>
                              </button>
                            </li> */}
                            <li>
                              <div className="blogBlock__date">
                                <span className="blogBlock__date__text">
                                  {blog.create_at}
                                </span>
                                <i className="fa-regular fa-clock"></i>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              <div className="row">
                <div className="col-12">
                  <div className="paginationBlock">
                    <nav aria-label="Page navigation example">
                      <ul className="pagination justify-content-center">
                        {/* Өмнөх */}
                        <li
                          className={`page-item page-item--prev ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageClick(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            <i className="fa-solid fa-angle-left"></i>
                          </button>
                        </li>

                        {/* Хуудасны дугаар */}
                        <div className="paginationBlock__number">
                          <ul>
                            {Array.from(
                              { length: totalPages },
                              (_, i) => i + 1,
                            ).map((num) => (
                              <li
                                key={num}
                                className={`page-item ${
                                  currentPage === num ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => handlePageClick(num)}
                                >
                                  {num}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* Дараагийнх */}
                        <li
                          className={`page-item page-item--next ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageClick(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            <i className="fa-solid fa-angle-right"></i>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
              <Mcc />
            </div>
          </section>
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};

export default MedeelelPage;
